// src/components/Layout/Layout.tsx
import React, { useEffect, useRef } from "react";
import Topbar from "./TopBar/TopBar";
import * as styles from "./Layout.module.scss";
import { WebSocketProvider } from "zeus-front-utils";
import { logger } from "../../core/logger";
import { log } from "console";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  // const handleMenuClick = () => {
  //   logger.info("Menu clicked");
  // };

  return (
    <WebSocketProvider>
      <div className={styles.layout}>
        {/* <Topbar
          title="Kiosko Zeus"
          onMenuClick={handleMenuClick}
          rightContent={<span>Usuario</span>}
        /> */}
        <main className={styles.main}>{children}</main>
      </div>
    </WebSocketProvider>
  );
};

export default Layout;
